import React, { useEffect } from 'react'
import "./InProgressJobsPage.css"
import JobDisplayGrid from '../../components/JobDisplayGrid/JobDisplayGrid';
import { useSelector,useDispatch } from 'react-redux';
import { fetchJobsInProgress } from './inProgressSlice';
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useNavigate } from 'react-router-dom';

const columns = [
  { field: "id", headerName: "ID", width: 70, headerClassName: 'id-header' },
  {
    field: "view",
    headerName: "View",
    headerClassName: 'centered-header',
    width: 80,
    sortable: false,
    renderCell: (params) => <ViewJobIcon params={params} />
  },
  {
    field: "jobName",
    headerName: "Job Name",
    width: 400,
    editable: false,
  },
  {
    field: "fileName",
    headerName: "File Name",
    width: 180,
    editable: false,
  },
  {
    field: "status",
    headerName: "Status",
    width: 180,
    editable: false,
  },
  {
    field: "jobType",
    headerName: "Job Type",
    width: 150,
    editable: false,
  },
  {
    field: "fileTemplate",
    headerName: "File Template",
    width: 150,
    editable: false,
  },
  {
    field: "createdDate",
    headerName: "Created Date",
    width: 250,
    editable: false,
  },
];

  const ViewJobIcon = ({ params }) => {
    const navigate = useNavigate()

    const handleViewClick = () => {
        return navigate(`/custome-rmatch-portal/jobRecords/${params.row.id}`)
    };
  
    return (
      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <MdOutlineRemoveRedEye
          style={{ cursor: 'pointer', fontSize: '1.8rem' }}
          onClick={handleViewClick}
        />
      </div>
    );
  };

  
const InProgressJobsPage = () => {
  // Authorization is now handled at the route level in ChiesiRoutes

  const dispatch = useDispatch();
  const { isAuthorised } = useSelector((state) => state.authentication);
  const loginState = useSelector((state) => state.authentication);
  const user_id = loginState.user.userId;
  
  useEffect(() => {
    dispatch(fetchJobsInProgress({ userId: user_id }))
      .catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error fetching jobs:', error);
      });
  }, [dispatch, user_id]);
  
  const rows = useSelector((state) => state.inProgressJobs.jobs);

  return (
    <>
      <div className="datagrid-container">
        <JobDisplayGrid rows={rows} columns={columns} />
      </div>
    </>
  );
};

export default InProgressJobsPage;